import i18next from 'i18next';

i18next.addResources('es_CL', 'NewOrderCounter', {
  message: '* Este pedido se aceptará automáticamente en {{seconds}} segundos.',
  autoAcceptMessage: '* Este pedido pasará a preparación automáticamente en {{seconds}} segundos.'
});

i18next.addResources('es_CR', 'NewOrderCounter', {
  message: '* Este pedido se aceptará automáticamente en {{seconds}} segundos.',
  autoAcceptMessage: '* Este pedido pasará a preparación automáticamente en {{seconds}} segundos.'
});
